type ErrorListener = (error: { title?: string; message: string; code?: string }) => void;

class ErrorBus {
  private listeners: ErrorListener[] = [];

  subscribe(listener: ErrorListener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  emit(error: { title?: string; message: string; code?: string }) {
    this.listeners.forEach(l => l(error));
  }
}

export const errorBus = new ErrorBus();
